import React from 'react';
import { AlertTriangle, X } from 'lucide-react';

interface SecurityWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function SecurityWarningModal({ isOpen, onClose }: SecurityWarningModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-[9999] flex items-center justify-center p-4">
      <div className="bg-card w-full max-w-md rounded-xl shadow-2xl border-2 border-red-500/50 overflow-hidden animate-in fade-in-0 zoom-in-95 duration-300 relative">
        {/* Header com botão X */}
        <div className="relative bg-gradient-to-r from-red-600 to-red-500 p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <AlertTriangle className="h-6 w-6 text-white" />
              <h2 className="text-lg font-bold text-white">
                AVISO DE SEGURANÇA
              </h2>
            </div>
            
            {/* Botão X bem grande e visível */}
            <button
              onClick={onClose}
              className="w-10 h-10 bg-white/20 hover:bg-white/30 text-white rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
              aria-label="Fechar"
            >
              <X className="h-6 w-6" strokeWidth={3} />
            </button>
          </div>
        </div>

        {/* Conteúdo simplificado */}
        <div className="p-6 text-center space-y-4">
          <div className="bg-red-500/10 border border-red-500/20 rounded-lg p-4">
            <h3 className="text-lg font-bold text-red-600 mb-3">
              🚫 EXTREMAMENTE PROIBIDO COMPARTILHAR SEU CÓDIGO DE ACESSO
            </h3>
            <p className="text-sm text-foreground leading-relaxed">
              O compartilhamento do seu código de acesso exclusivo com terceiros resultará em:
            </p>
            <div className="mt-3 space-y-1 text-sm">
              <p>• <strong>BLOQUEIO IMEDIATO</strong> da sua conta</p>
              <p>• <strong>PERDA PERMANENTE</strong> do acesso à plataforma</p>
              <p>• <strong>MONITORAMENTO ATIVO</strong> de todas as atividades</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}